import useMountEffect from "../hooks/useMountEffect";

export const RedirectAction = (props: {action: () => void}) => {
  useMountEffect(() => {
    props.action();
  });

  return null;
};
